/**
 * @file MedicalReport.ts
 * @brief Medical Assessment's own icon: a signed report with a medical cross (was lucide FileHeart; trial on mobile).
 *
 * @details
 * Mirrors the mobile app's `FRONTEND/src/shared/components/icons/MedicalReport.ts`
 * (DES 08-10-2026, app-specific icons): identical geometry and keys, built
 * with lucide-react's `createLucideIcon` so it takes the same props
 * (size, className, strokeWidth, color) as every lucide icon.
 *
 * @author DES
 * @date 08-10-2026
 */

import { createLucideIcon } from "lucide-react";

export const MedicalReport = createLucideIcon("MedicalReport", [
  ["path", { d: "M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z", key: "page" }],
  ["path", { d: "M14 2v6h6", key: "fold" }],
  ["path", { d: "M9 7v4", key: "cross-v" }],
  ["path", { d: "M7 9h4", key: "cross-h" }],
  [
    "path",
    {
      d: "M7.5 17.5c1-1.5 2-2.5 2.5-1s.5 2 1.5.5 1.5-2 2.5-.5 1 1 2.5.5",
      key: "signature",
    },
  ],
]);

export default MedicalReport;
